<template>
  <div class="home data-panel-home">
    <Header title="提现记录"></Header>
    <div class="selectInput">
      <div class="left-wrap">选择查询账号：</div>
      <el-select class="commit_channel" v-model="selectEmail" placeholder="请选择"  @change="changeSelectEmail">
        <el-option
        v-for="item in emailList"
        :key="item"
        :label="item"
        :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="wechat-revenue-info">
      <el-table
        v-if="buyBackList !== 'NONE'"
        :data="buyBackList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="time"
          label="发起时间（UTC）"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="exchangeMoney"
          label="提现金额"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="exchangeBXC"
          label="提现所需BP数量"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="ZFBAccount"
          label="收款支付宝账号"
          align='center'
        >
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">已提交</span>
            <span v-else-if="scope.row.status === 1">打款完成</span>
            <span v-else-if="scope.row.status === 2">账号错误</span>
            <span v-else-if="scope.row.status === 3">已提交</span>
            <span v-else>已提交</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="buyBackList === 'NONE'"
        :empty-text="$t('withdrawal.recordsList.noWithdrawalList')"
      ></el-table>
      <!-- 分页 -->
      <div style="text-align: right; margin-top: 15px">
        <el-pagination 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage"
        :page-size="pagesize" 
        layout="total, prev, pager, next " 
        :total="buyBackList.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { Message } from "element-ui";
import { getCookie } from "@/utils/utils";

export default {
  name: "home",
  components: {
    Header,
  },
  data() {
    return {
      emailList:[],
      selectEmail:'',
      selectId:'',
      currentPage:1,
      pagesize:5,
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails,
    email: (state) => state.account.email,
    buyBackList: (state) => state.buyBack.buyBackList,
  }),
  async created() {
    try {
      let openid = getCookie("openid") || this.$route.query.openid;
      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fbuybackList";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;

      if (openid || code) {
        this.openId = openid;
        this.getWechatInfo({ openid, code }).then(res=>{
          console.log(res);
          this.emailList = res.emails;
        })
      } else {
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions([
      "getWechatInfo", //用户email
      "getWechatTelFromEmail",//用户tel
      "getBuyBackList",
    ]),
    changeSelectEmail(val){
      let email = val;
      this.getWechatTelFromEmail({ email }).then(res=>{
        this.selectId = res.id;
        let userId = this.selectId;
        this.getBuyBackList({ userId:userId });
      })
    },
    handleSizeChange(size){
      this.pagesize = size;
    },
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    }
 }
};
</script>

<style>
  .selectInput{
    padding: 0px 10px; 
    display: flex;
    justify-content: 
    space-between;
    align-items: center;
  }
</style>

